/** Stable, lossless raffle label. This is a display number, never an admission credential. */
export function formatTicketRaffleNumber(ticketId: number): string {
  if (!Number.isSafeInteger(ticketId) || ticketId < 1) {
    throw new RangeError("Ticket ID must be a positive safe integer.");
  }
  return `R-${ticketId.toString(36).toUpperCase().padStart(4, "0")}`;
}
